<template>
  <footer class="app-footer">
    <div class="footer-top">
      <button class="back-to-top-btn" @click="scrollToTop">Back to top</button>
    </div>
    <div class="footer-middle">
      <div class="footer-left">
        <button
          class="footer-link footer-link--btn"
          :class="{ 'footer-link--disabled': currentScreen === 'FoldingDirectionsScreen' }"
          :disabled="currentScreen === 'FoldingDirectionsScreen'"
          @click="$store.commit('setScreen', 'FoldingDirectionsScreen')"
        >Folding directions</button>
        <a
          v-if="currentScreen !== 'HowToUseScreen'"
          class="footer-link"
          href="?screen=HowToUseScreen"
          target="_blank"
        >How to use</a>
        <button
          v-else
          class="footer-link footer-link--btn footer-link--disabled"
          disabled
        >How to use</button>
        <a class="footer-email" href="mailto:Hi@roxanneg.design">Hi@roxanneg.design</a>
      </div>
      <div class="footer-social">
        <a href="https://www.linkedin.com/in/roxanne-g-ux/" class="footer-link" target="_blank" rel="noopener">linkedIN</a>
        <a href="https://roxanneg.design/#contact" class="footer-link" target="_blank" rel="noopener">submit a bug</a>
      </div>
    </div>
    <div class="footer-credits">
      <a href="https://roxanneg.design" class="footer-link" target="_blank" rel="noopener">roxanneg.design</a>
      <a href="https://boutell.dev" class="footer-link" target="_blank" rel="noopener">boutell.dev</a>
      <a href="https://www.anthropic.com/news/claude-sonnet-4-6" class="footer-link" target="_blank" rel="noopener">claude code</a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  props: {
    currentScreen: {
      type: String,
      default: ''
    }
  },
  methods: {
    scrollToTop() {
      this.$el.parentElement.scrollIntoView();
    }
  }
}
</script>

<style scoped>
.app-footer {
  flex-shrink: 0;
  background-color: var(--surface-darkest);
  padding: 32px 56px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-end;
  font-family: var(--font-family-balsamiq);
  font-size: var(--font-size-16);
  color: var(--text-bright);
}

.footer-top {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.back-to-top-btn {
  background-color: var(--surface-darkest);
  border: 2px solid var(--text-bright);
  color: var(--text-bright);
  font-family: var(--font-family-balsamiq);
  font-size: var(--font-size-16);
  line-height: var(--font-line-height-24);
  padding: 7px 16px;
  border-radius: 1px;
  cursor: pointer;
  filter: url(#button-stroke);
}

.footer-middle {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
}

.footer-email,
.footer-link {
  color: var(--text-bright) !important;
  font-size: var(--font-size-16);
  line-height: var(--font-line-height-24);
  text-decoration: underline;
  text-decoration-skip-ink: none;
  white-space: nowrap;
}

.footer-email:link,
.footer-link:link,
.footer-email:visited,
.footer-link:visited,
.footer-email:active,
.footer-link:active {
  color: var(--text-bright) !important;
}

.footer-email:hover,
.footer-link:hover {
  color: var(--text-lightest) !important;
}

.footer-left {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
}

.footer-link--btn {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
}

.footer-link--disabled {
  opacity: 0.45;
  cursor: default;
}

.footer-social {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-end;
  text-align: right;
}

.footer-credits {
  display: flex;
  gap: 24px;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
}

@media screen and (max-width: 560px) {
  .app-footer {
    padding: 32px 40px;
    align-items: center;
    text-align: center;
    gap: 32px;
    margin-top: auto;
  }

  .footer-top {
    justify-content: center;
  }

  .footer-middle {
    flex-direction: column;
    align-items: center;
    gap: 32px;
  }

  .footer-left {
    align-items: center;
  }

  .footer-social {
    align-items: center;
    text-align: center;
    gap: 16px;
  }

  .footer-credits {
    position: relative;
    margin-top: 16px;
    padding-top: 32px;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 24px;
  }

  .footer-credits::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 16px;
    background: linear-gradient(
      to bottom,
      transparent calc(50% - 0.5px),
      var(--text-bright) calc(50% - 0.5px),
      var(--text-bright) calc(50% + 0.5px),
      transparent calc(50% + 0.5px)
    );
    filter: url(#hand-drawn-line);
    pointer-events: none;
    z-index: 1;
  }
}
</style>
